export const formatToIST = (d) => {
  const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(d);
  const mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(d);
  const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(d);
  // return `${da}-${mo}-${ye}`;
  return `${ye}-${mo}-${da}`;
};
